<script>
    import HistoryButton from "./history-button.svelte";
    import Jackpot from "./jackpot.svelte";
    // import Denom from "./denom.svelte";
    import { balance, jackpots, historyState, denomination/*, denominations*/ } from "./stores";
    $: jackpotsData = [
        { image: "ruby.png", x: 9, text: $jackpots?.diamond },
        { image: "gold.png", x: 29, text: $jackpots?.gold },
        { image: "silver.png", x: 49, text: $jackpots?.silver },
        {
            image: "credits.png",
            x: 69,
            width: 28.854,
            height: 4.739583,
            y: 0,
            text: ($balance / $denomination).toFixed(0),
            defaultText: "0",
        },
    ];
</script>

<div>
    <HistoryButton />
    {#if $historyState === 0}
        {#each jackpotsData as { image, x, y, width, height, text, defaultText = "" }}
            <Jackpot {image} {x} {y} {width} {height} {text} {defaultText} />
        {/each}
        <!-- {#if $denominations.length > 1}
            <Denom image="denom.png" x=73 y=3.3 width=5 height=2 defaultText="1.00" />
        {/if} -->
    {/if}
</div>

<style>
    div {
        width: 100%;
        height: 10%;
    }
</style>
